export const POSTHOG_EVENTS = {
  COMAPNY_REVEAL_CLICKED: "company_reveal_clicked",
  COMPANY_REVEAL_CANCELLED: "company_reveal_cancelled",
  COMPANY_GPT_SEARCH_EMPLOYEES: "company_gpt_search_employees",
  COMPANY_GPT_SEARCH_AI_CASE_STUDY: "company_gpt_search_ai_case_study",
  SUPPORT_EMAIL_CLICKED: {
    DASHBOARD: "support_email_clicked:get_full_access",
    USAGE_TABLE: "support_email_clicked:usage_table",
    SUBSCRIPTION_PAGE: "support_email_clicked:subscription_page",
  },
  TALK_TO_FOUNDERS: {
    HEADER: "talk_to_founders:header",
  },
  EXPORT: {
    OPPORTUNITIES: "export:opportunities",
    FORM_RESPONSES: "export:form_responses",
  },
  HOMEPAGE: {
    GET_STARTED_CLICKED: "homepage:get_started_btn_clicked",
    WAITLIST_CLICKED: "homepage:waitlist_btn_clicked",
    SIGN_IN_CLICKED: "homepage:sign_in_btn_clicked",
  },
  AUTH: {
    LOGIN_PAGE_VIEWED: "auth:login_page_viewed",
    OAUTH_EMAIL_SELECTED: "auth:oauth_email_selected",
    OAUTH_EMAIL_ERROR: "auth:oauth_email_error",
    SIGN_UP_SUCCESSFUL: "auth:sign_up_successful",
    LOGIN_SUCCESSFUL: "auth:login_successful",
  },
  BILLING: {
    PAYWALL_SHOWN: "billing:paywall_shown",
    PAYMENT_ATTEMPTED: "billing:payment_attempted",
    PAYMENT_SUCCESSFUL: "billing:payment_successful",
    PAYMENT_FAILED: "billing:payment_failed",
  },
  GMAIL_INTEGRATION: {
    PROMPT_SHOWN: "gmail_integration:gmail_connect_prompt_shown",
    CONNECTED: "gmail_integration:gmail_connected",
    CONNECT_FAILED: "gmail_integration:gmail_connect_failed",
  },
  ONBOARDING: {
    SAMPLE_DATA_CREATED: "onboarding:sample_data_created",
    WORKSPACE_READY: "onboarding:workspace_ready",
  },
};
